import React from 'react';
import { Handle, Position } from 'reactflow';

export default function ValueNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #ec4899',
      background: 'var(--card)',
      minWidth: 130,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#f472b6' }}>
        🔢 Value
      </div>
      <input
        type="number"
        value={data.value ?? 0}
        onChange={(e) => onChange('value', parseFloat(e.target.value) || 0)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        step="any"
      />
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#ec4899' }} />
    </div>
  );
}
